<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerText]="(T.CONFIGURATION_EDITOR_CAMERA_VIDEO_SOURCE_DIALOG_TITLE | translate) + data.camera.ipAddress + '  ' + data.camera.name"
	[headerIcon]="{fontIcon: 'fa-camera-home', fontSet: 'fad'}"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<div class="row">
			<div class="col-lg-6 col-md-6 col-sm-6">
				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_FFMPEG_TRANSPORT_PROTOCOL | translate }}
						</mat-label>
						<mat-select [(ngModel)]="data.camera.configuration.ffmpegTransportProtocol">
							@for (transportProtocol of transportProtocols; track transportProtocol) {
								<mat-option [value]="transportProtocol.value">
									{{ transportProtocol.name }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<button
						(click)="updateAllCameras('FfmpegTransportProtocol', data.camera.configuration.ffmpegTransportProtocol)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>

				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label>{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_BACKEND_PROXY_TYPE | translate }}</mat-label>
						<mat-select [(ngModel)]="data.camera.configuration.backendProxyType">
							@for (backendProxyType of backendProxyTypes; track backendProxyType) {
								<mat-option [value]="backendProxyType.value">
									{{ backendProxyType.name }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<button
						(click)="updateAllCameras('BackendProxyType', data.camera.configuration.backendProxyType)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>

				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label>{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_CAMERA_PROXY_TYPE | translate }}</mat-label>
						<mat-select [(ngModel)]="data.camera.configuration.cameraProxyType">
							@for (cameraProxyType of cameraProxyTypes; track cameraProxyType) {
								<mat-option [value]="cameraProxyType.value">
									{{ cameraProxyType.name }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
					<button
						(click)="updateAllCameras('CameraProxyType', data.camera.configuration.cameraProxyType)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>

				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label style="pointer-events: auto">
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_RECORDING_TIMEOUT | translate }}
							<i
								[matTooltip]="T.CONFIGURATION_DIALOG_CAMERA_CONFIGURATION_RECORDING_TIMEOUT_TOOLTIP | translate"
								class="fad fa-info-circle"
								style="margin-left: 3px"
							>
							</i>
						</mat-label>
						<input [(ngModel)]="data.camera.configuration.recordingTimeout" matInput type="number" />
					</mat-form-field>
					<button
						(click)="updateAllCameras('RecordingTimeout', data.camera.configuration.recordingTimeout)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>

				<div class="styleFlex" style="margin-top: 10px">
					<mat-checkbox [(ngModel)]="data.camera.configuration.isSecure">
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_ACCESS_VIDEO_OVER_HTTPS | translate }}
					</mat-checkbox>
					<button
						(click)="updateAllCameras('IsSecure', data.camera.configuration.isSecure)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>
				<div class="styleFlex" style="margin-top: 20px">
					<mat-checkbox [(ngModel)]="data.camera.configuration.useWallclockAsTimestamps">
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_USE_WALLCLOCK_AS_TIMESTAMPS | translate }}
					</mat-checkbox>
					<button
						(click)="updateAllCameras('UseWallclockAsTimestamps', data.camera.configuration.useWallclockAsTimestamps)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						style="width: fit-content; align-item: center"
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>
			</div>
			<div class="col-lg-6 col-md-6 col-sm-6">
				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_CAMERA_PROXY | translate }}
						</mat-label>
						<input [(ngModel)]="data.camera.configuration.cameraProxy" matInput type="text" />
					</mat-form-field>
					<button
						(click)="updateAllCameras('CameraProxy', data.camera.configuration.cameraProxy)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>

				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_BACKEND_PROXY | translate }}
						</mat-label>
						<input [(ngModel)]="data.camera.configuration.backendProxy" matInput type="text" />
					</mat-form-field>
					<button
						(click)="updateAllCameras('BackendProxy', data.camera.configuration.backendProxy)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>

				@if (
					data.camera.deviceType === DeviceType.GenericRTSP &&
					data.camera.configuration.cameraProxyType === CameraProxyType.RtspWebRtc
				) {
					<div class="styleFlex">
						<mat-form-field color="accent">
							<mat-label>Stream Path Override (explicit url to use for rtsp restreamer)</mat-label>
							<input [(ngModel)]="data.camera.configuration.streamPathOverride" matInput type="text" />
						</mat-form-field>
						<button
							(click)="updateAllCameras('StreamPathOverride', data.camera.configuration.streamPathOverride)"
							[appBusy]="updateAllCamerasTask"
							[busyOption]="'disable-class'"
							class="btn btn-default"
							color="accent"
							mat-stroked-button
							type="button"
						>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
							<i class="fad fa-sync-alt"></i>
						</button>
					</div>
				}
				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label>{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_USER_NAME | translate }}</mat-label>
						<input [(ngModel)]="data.camera.configuration.username" matInput type="text" />
					</mat-form-field>
					<button
						(click)="updateAllCameras('Username', data.camera.configuration.username)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>
				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label>{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_PASSWORD | translate }}</mat-label>
						<input [(ngModel)]="data.camera.configuration.password" matInput type="password" />
					</mat-form-field>
					<button
						(click)="updateAllCameras('Password', data.camera.configuration.password)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>
				<div class="styleFlex">
					<mat-form-field color="accent">
						<mat-label>
							{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_SOURCE_CAMERA_NUMBER | translate }}
						</mat-label>
						<input [(ngModel)]="data.camera.configuration.sourceCameraNumber" matInput type="number" />
					</mat-form-field>
					<button
						(click)="updateAllCameras('SourceCameraNumber', data.camera.configuration.sourceCameraNumber)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>

				<div class="styleFlex" style="margin-top: 20px">
					<mat-checkbox [(ngModel)]="data.camera.configuration.recordAudio">
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_RECORD_AUDIO | translate }}
					</mat-checkbox>
					<button
						(click)="updateAllCameras('RecordAudio', data.camera.configuration.recordAudio)"
						[appBusy]="updateAllCamerasTask"
						[busyOption]="'disable-class'"
						class="btn btn-default"
						color="accent"
						mat-stroked-button
						type="button"
					>
						{{ T.CONFIGURATION_EDITOR_CAMERA_CONFIGURATION_UPDATE_FOR_ALL_CAMERAS | translate }}
						<i class="fad fa-sync-alt"></i>
					</button>
				</div>
			</div>
		</div>
	</ng-container>

	<ng-container actions>
		@if (canUpdateAllCamerasOfType()) {
			<button (click)="updateAllCamerasOfType()" class="btn btn-default large" color="accent" mat-raised-button>
				{{ T.CONFIGURATION_EDITOR_CAMERA_USE_FOR_ALL_CAMERAS | translate: {cameraType: updateAllCamerasOfTypeText()} }}
			</button>
		}

		<sim-button (onClick)="close()" [icon]="{fontSet: 'fal', fontIcon: 'fa-times'}" [label]="T.BUTTON_CANCEL" [color]="'warn'" />

		<sim-button
			(onClick)="ok()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
			[color]="'accent'"
		/>
	</ng-container>
</sim-basic-material-dialog>
